<style>
    @import url('https://fonts.googleapis.com/css2?family=Noto+Sans:wght@600&family=Roboto+Slab:wght@400;600;700&display=swap');
  </style>
<div *ngFor="let event of events" let event="task" style="font-family: Roboto Slab">
    <div class="item" *ngIf="event" >
        <div class="event-info">
            <p>{{ event.date }}</p>
            <p>{{ event.location }}</p>
            <p> {{ event.time }}</p>
            <p style="font-weight: bold;">Price: {{event.price}}</p>

        </div>
        <div class="event" >
            <mat-card class="container">
                <div class="event-image">
                    <img src={{event.image}} alt="Event Image">
                </div>
                <div class="event-content">
                    <p style="font-family: Roboto Slab">
                        <h2>{{ event.title }}</h2>
                        <h3><a [routerLink]="['/vieworg', event.org]">{{ event.orgName }}</a></h3>
                        <p>{{ event.description }}</p>
                        <p *ngIf="isOrg===true">Number Going: {{ event.interested }}</p>
                        <p>Tags: {{event.tags}}</p>
                        <!-- <div *ngFor="let interests of " let interest="task">
                        <p>{{interests}}</p>
                    </div> -->
                </div>
            </mat-card>
            <div class="event-buttons">
                <button *ngIf="isAdmin===true" mat-raised-button (click)="deleteEvent(event.title)">Delete</button>
                <button *ngIf="isOrg===true" mat-raised-button (click)="editEvent(event)">Edit</button>
                <button *ngIf="isUser===true" mat-raised-button (click)="joinEvent(event)">I'm Interested</button>
            </div>
        </div>
    </div>
</div>